// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3_A5J","title":"styles_title__2cz9h","saveButton":"styles_saveButton__29psJ"};